import React from "react";
import { TypeColorNames } from '../../../theme/colors';
import styled from "styled-components";

const IconContainer = styled.span`
    display: flex;
    align-items: center;
`;
export interface ITrianglesIcon {
    
    style?: React.CSSProperties;
    colorSecondary: TypeColorNames;
  }

const TrianglesIcon: React.FC<ITrianglesIcon> = ({colorSecondary, style}) => {

    return(
        <IconContainer style={{...style}}>
            <svg
              width="60"
              height="22"
              viewBox="0 0 60 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.963 20.9918L1.00488 11.0001L10.963 1.0083V20.9918Z"
                // stroke={getColor(colorSecondary)}
                stroke={colorSecondary}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M34.9791 20.9918L25.021 11.0001L34.9791 1.0083V20.9918Z"
                // stroke={getColor(colorSecondary)}
                stroke={colorSecondary}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M58.9951 20.9918L49.037 11.0001L58.9951 1.0083V20.9918Z"
                stroke={colorSecondary}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
        </IconContainer>
    )
}

export default TrianglesIcon;

